const generateScheduleBlock = (id, title, imageUrl) => {
	const template = document.querySelector('._template-block > .image-block').cloneNode(true);
	template.setAttribute('href', `schedules/${id}`);
	template.setAttribute(
		'style',
		`background-image: url(${imageUrl})`,
	);
	template.lastChild.innerText = title;

	return template;
};

export default generateScheduleBlock;



// WEBPACK FOOTER //
// ./src/js/transportation/generateScheduleBlock.js